module.exports = function() {
  return new Worker(__webpack_public_path__ + "685bab8ce0af07c1ae59.worker.js");
};